import type { components } from "@/api-schema";
import { EMPTY_VALUE_PLACEHOLDER } from "@/components/ui/empty-value";

export enum UserNameFormat {
  Formal = "Formal",
  Personal = "Personal",
}

export const USER_NAME_FALLBACK = EMPTY_VALUE_PLACEHOLDER;

type UserNameParts = Partial<Pick<components["schemas"]["User"], "firstName" | "lastName" | "email">>;

type GetFullUserNameOptions = {
  user: UserNameParts;
  format?: UserNameFormat;
  /** Use the email when the user has no name. Disable where an email is no valid name, e.g. avatar initials. */
  emailFallback?: boolean;
  fallback?: string;
};

/**
 * Formats a user name. Fallback order: name, email (if enabled), `fallback`.
 */
export function getFullUserName({
  user,
  format = UserNameFormat.Formal,
  emailFallback = true,
  fallback = USER_NAME_FALLBACK,
}: GetFullUserNameOptions): string {
  const firstName = user.firstName?.trim();
  const lastName = user.lastName?.trim();

  const name =
    format === UserNameFormat.Formal
      ? [lastName, firstName].filter(Boolean).join(", ")
      : [firstName, lastName].filter(Boolean).join(" ");

  return name || (emailFallback ? user.email?.trim() : undefined) || fallback;
}
